import { render, staticRenderFns } from "./MemberClientsManagement.vue?vue&type=template&id=4eafd044&scoped=true&"
import script from "./MemberClientsManagement.vue?vue&type=script&lang=ts&"
export * from "./MemberClientsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./MemberClientsManagement.vue?vue&type=style&index=0&id=4eafd044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eafd044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VHover,VIcon,VProgressCircular,VRow,VSnackbar})
